'use client';
import React from 'react';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  ReferenceLine,
} from 'recharts';

const weightData = [
  { month: 'Jan', weight: 3.6 },
  { month: 'Feb', weight: 3.8 },
  { month: 'Mar', weight: 3.9 },
  { month: 'Apr', weight: 4.0 },
  { month: 'May', weight: 3.8 },
  { month: 'Jun', weight: 4.1 },
  { month: 'Jul', weight: 4.2 },
];

const CustomTooltip = ({ active, payload, label }: { active?: boolean; payload?: { value: number }[]; label?: string }) => {
  if (active && payload && payload.length) {
    return (
      <div className="bg-white border border-border rounded-xl shadow-float px-4 py-3">
        <p className="text-xs font-bold text-muted-foreground">{label} 2026</p>
        <p className="text-base font-extrabold text-foreground">{payload[0].value} kg</p>
        <p className="text-xs text-secondary font-semibold">Healthy range ✓</p>
      </div>
    );
  }
  return null;
};

export default function PetHealthChart() {
  return (
    <ResponsiveContainer width="100%" height={200}>
      <LineChart data={weightData} margin={{ top: 5, right: 10, left: -10, bottom: 5 }}>
        <CartesianGrid strokeDasharray="3 3" stroke="var(--border)" />
        <XAxis
          dataKey="month"
          tick={{ fontSize: 11, fontWeight: 600, fill: 'var(--muted-foreground)' }}
          axisLine={false}
          tickLine={false}
        />
        <YAxis
          domain={[3.0, 5.0]}
          tick={{ fontSize: 11, fontWeight: 600, fill: 'var(--muted-foreground)' }}
          axisLine={false}
          tickLine={false}
          tickFormatter={(v) => `${v}kg`}
        />
        <Tooltip content={<CustomTooltip />} />
        <ReferenceLine y={4.5} stroke="var(--accent)" strokeDasharray="4 4" strokeWidth={1.5} label={{ value: 'Max', fontSize: 10, fill: 'var(--accent-dark)' }} />
        <ReferenceLine y={3.5} stroke="var(--secondary)" strokeDasharray="4 4" strokeWidth={1.5} label={{ value: 'Min', fontSize: 10, fill: 'var(--secondary)' }} />
        <Line
          type="monotone"
          dataKey="weight"
          stroke="var(--primary)"
          strokeWidth={2.5}
          dot={{ fill: 'var(--primary)', r: 4, strokeWidth: 2, stroke: '#fff' }}
          activeDot={{ r: 6, fill: 'var(--primary)', stroke: '#fff', strokeWidth: 2 }}
        />
      </LineChart>
    </ResponsiveContainer>
  );
}